<template>
  <div v-if="showLoading" id="loadingNode" class="loading-wrap" :class="[ownClass ? ownClass : '']">
    <span class="icon-loading" :class="[whiteIcon ? 'white-icon' : '']" v-if="typeLoading == 'single'"></span>
    <div class="sign-loading-mask" :class="loadingClass" v-else>
      <div class="sign-loading-wrap">
        <!-- icon_type success/error 特殊处理
        --- gif图先出现动画之后保持静止
        --- 添加时间戳，重新加载动图-->
        <span class="icon icon-spec" v-if="icon_type && ['success', 'error'].indexOf(icon_type) != -1">
          <img v-if="icon_type == 'success'" :src="successImg" />
          <img v-else-if="icon_type == 'error'" :src="errorImg" />
        </span>
        <span v-else-if="icon_type" class="icon" :class="icon_type"></span>
        <div class="loading-text" v-if="loadingText">
          <p v-for="item in text" :key="item">{{ item }}</p>
        </div>
        <img @click="closeLoading" class="loading-close" v-if="showCloseBtn" src="./icons/close-grey.svg" />
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
/*
*@author lianjf
*
* @param {string}     loadingText    要显示的文字      非必传 需要多行排列时，加上换行识别符号 &
* @param {string}     icon_type      图标             非必传  值:[success,error,print,check,loading] 
* @param {boolean}    showLoading    是否显示         非必传 
* @param {string}     ownClass       自定义容器class   非必传
*
* @param {string}     typeLoading    loading三种形式   非必传
* 
* 第一种：no-mask-grey   没有遮罩层，没有白色弹框，灰色loading加文字
* 第二种：no-box-white   没有遮罩层，没有白色弹框，白色loading加白色文字
* 第三种： 有遮罩层，有白色弹框，灰色loading加灰色文字  默认
* 第四种： 无遮罩层，有灰色底框，白色loading  
** @param {boolean}     whiteIcon   使用白色loading的icon   非必传

*使用方法 this.myLoading('加载中')  || this.myLoading({loadingText:'加载中&请稍后片刻'，icon_type:'success'})
*
*/
export default {
  data () {
    return {
      loadingText: "",
      icon_type: "loading",
      showLoading: true,
      autoHide: false,
      ownClass: "",
      typeLoading: "",
      whiteIcon: false,
      showCloseBtn: false,
      closeTimeout: null,
      noPlayVoice: false, //不播放声音
    };
  },
  // props:['loadingText','ownClass','typeLoading','whiteIcon'],
  mounted () {
    this.closeTimeout = setTimeout(() => {
      this.showCloseBtn = true;
    }, 30000);
  },
  computed: {
    loadingClass () {
      switch (this.typeLoading) {
        case "no-mask-grey":
          return "no-mask";
          break;
        case "no-box-white":
          return "no-box";
          break;
        case "no-mask-box-white":
          return "no-mask-box-white";
          break;
        default:
          return "";
          break;
      }
    },
    text () {
      this.setTimeout10CLose();
      if (document.getElementById("loadingNode")) {
    
      }
      return this.loadingText.split("&");
    },
    successImg () {
      return "static/img/pic_wancheng.gif?"+ new Date().getTime();
    },
    errorImg () {
      return  "static/img/pic_shibai.gif?"+ new Date().getTime();
    }
  },
  methods: {
    closeLoading () {
      this.showLoading = false;
      //销毁组件
      this.$destroy(true);
      //移除节点
      this.$el.parentNode && this.$el.parentNode.removeChild(this.$el);
    },
    setTimeout10CLose () {
      if (this.icon_type === "loading" || !this.autoHide) {
        return false;
      }
      this.timeoutNum = setTimeout(() => {
        this.closeLoading();
      }, 5000);
    }
  },
  beforeDestroy () {
    this.closeTimeout = null;
    this.timeoutNum = null;
  }
};
</script>

<style lang="less">
.loading-wrap {
  .sign-loading-mask {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 3333;
    .sign-loading-wrap {
      width: 200px;
      height: 144px;
      background: rgba(0, 0, 0, 0.7);
      position: relative;
      .loading-close {
        position: absolute;
        top: -13px;
        right: -13px;
      }
    }
    &.no-mask {
      background: none;
      .sign-loading-wrap {
        background: none;
        box-shadow: none;
      }
    }
    &.no-box {
      background: none;
      .sign-loading-wrap {
        background: none;
        box-shadow: none;
        .icon-loading {
          background-image: url("~@img/flow_reuse/dialog/loading-white.gif");
        }
        .loading-text {
          color: white;
        }
      }
    }
    &.no-mask-box-white {
      background: none;
      .sign-loading-wrap {
        box-shadow: none;
        width: 140px;
        height: 140px;
        background: rgba(0, 0, 0, 0.9);
        border-radius: 6px;
      }
      .icon-loading {
        margin-top: 34px !important;
        background-image: url("./icons/loading-white.svg");
      }
    }
    .sign-loading-wrap {
      margin: 0 auto;
      border-radius: 10px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .icon {
        width: 100px;
        height: 80px;
        background-repeat: no-repeat;
        background-position: center;
        background-size: 80%;
        &.icon-spec {
          img {
            transform: translate(-2px, -2px);
          }
        }
        &.loading {
          width: 60px;
          height: 60px;
          background-image: url("~@img/flow_reuse/dialog/loading-grey.gif");
        }
      }
      .loading-text {
        display: inline-block;
        width: 100%;
        font-size: 16px;
        color: #fff;
        letter-spacing: 0;
        text-align: center;
        line-height: 18px;
        // color: red;
        p {
          margin: 0;
        }
      }
    }
  }
}
// @keyframes rotation {
//   from {
//     -webkit-transform: none;
//     -ms-transform: none;
//   }
//   to {
//     -webkit-transform: rotate(360deg);
//     -ms-transform: rotate(360deg);
//   }
// }
</style>


// WEBPACK FOOTER //
// src/lib/ui/default/loading/src/loading.vue